import { FlexColumn, Loading, useLoading } from '@gorila-shared-ui/components';
import { HeadingXSmall } from 'baseui/typography';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useFeedback } from '../../../hooks/useFeedback';
import { useStyles } from '../../../hooks/useStyles';
import { getNotification } from '../../../services/notificationService';
import { apiParamsState } from '../../../storage/app';
import { notificationSelectedState } from '../../../storage/notifications';
import { NotificationLinkableSection } from '../../../types/notification';
import { FloatingCardsLayout } from '../../layout/FloatingCardsLayout';
import { FloatingCardContent } from '../../layout/cards/FloatingCardContent';
import { HistoricNotificationList } from '../../notifications/HistoricNotificationList';
import NotificationEvidences from '../../notifications/NotificationEvidences';
import { NotificationInfo } from '../../notifications/NotificationInfo';

function NotificationPage() {
  const { theme, css } = useStyles();
  const apiParams = useRecoilValue(apiParamsState);
  const { notificationId } = useParams();
  const [selectedNotification, setSelectedNotification] = useRecoilState(notificationSelectedState);
  const { loading, startLoading, stopLoading } = useLoading();
  const { showFailFeedback } = useFeedback();
  const [initialLoad, setInitialLoad] = useState(false);

  useEffect(() => {
    if (initialLoad) {
      setInitialLoad(false);
      return;
    }
    const loadNotification = async () => {
      if (!apiParams?.clientId || !notificationId || !apiParams?.subClientId) return;
      startLoading();
      const { notification, error } = await getNotification(
        apiParams.clientId,
        apiParams.subClientId,
        selectedNotification?._id ?? notificationId,
      );
      if (!error && notification) {
        setSelectedNotification(notification);
      } else {
        showFailFeedback(error ?? 'Ocurrió un error al cargar la notificación.');
        setSelectedNotification(undefined);
      }
      setInitialLoad(true);
      stopLoading();
    };

    loadNotification();
  }, [apiParams?.clientId, notificationId, apiParams?.subClientId, selectedNotification]);

  return (
    <FloatingCardsLayout
      listSize={480}
      list={
        <FloatingCardContent
          flexible
          gap={theme.sizing.scale600}
          classNames={css({ height: '100%', overflow: 'hidden' })}
        >
          <FlexColumn classNames={css({ flex: 1, overflow: 'hidden' })}>
            <FlexColumn classNames={css({ minHeight: '176px' })}>
              {loading && <Loading />}
              {!loading && <NotificationInfo notification={selectedNotification} />}
            </FlexColumn>
            {(!loading || selectedNotification) && <HistoricNotificationList />}
          </FlexColumn>
        </FloatingCardContent>
      }
      contentSize={280}
      content={
        selectedNotification &&
        selectedNotification.actions?.viewDetails.section === NotificationLinkableSection.alarmEvidences && (
          <FloatingCardContent
            flexible
            gap={theme.sizing.scale600}
            classNames={css({ height: '100%', overflow: 'hidden' })}
          >
            <HeadingXSmall margin={0}>Evidencias</HeadingXSmall>
            <NotificationEvidences notification={selectedNotification} />
          </FloatingCardContent>
        )
      }
    />
  );
}

export default NotificationPage;
